var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentFailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 127 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3743 10.4032C20.3743 4.65767 25.0474 0 30.812 0H96.987C104.92 0 111.363 6.36031 111.463 14.244H112.521C120.516 14.244 126.998 20.7039 126.998 28.6726V75.7398C126.998 83.7086 120.516 90.1681 112.521 90.1681H47.859V83.6056H112.521C116.879 83.6056 120.413 80.0842 120.413 75.7398V28.6726C120.413 24.3282 116.879 20.8065 112.521 20.8065H30.812C29.451 20.8065 28.1508 20.5468 26.9586 20.0745V55.7813H20.3743V10.4032ZM26.9586 10.4032C26.9586 12.5244 28.6839 14.244 30.812 14.244H104.877C104.779 9.98491 101.284 6.5625 96.987 6.5625H30.812C28.6839 6.5625 26.9586 8.28207 26.9586 10.4032Z",
    fill: "#EF5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2876 50.6688C67.2876 41.1608 75.0209 33.4531 84.5602 33.4531H126.998V67.8842H84.5602C75.0209 67.8842 67.2876 60.1765 67.2876 50.6688ZM84.5602 40.0156C78.6574 40.0156 73.8719 44.7849 73.8719 50.6688C73.8719 56.5521 78.6574 61.3217 84.5602 61.3217H120.414V40.0156H84.5602Z",
    fill: "#EF5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5608 52.4556C85.557 52.4556 86.3649 51.6503 86.3649 50.6574C86.3649 49.6645 85.557 48.8593 84.5608 48.8593C83.5646 48.8593 82.7567 49.6645 82.7567 50.6574C82.7567 51.6503 83.5646 52.4556 84.5608 52.4556ZM84.5608 59.0181C89.1935 59.0181 92.9492 55.2748 92.9492 50.6574C92.9492 46.0401 89.1935 42.2969 84.5608 42.2969C79.9281 42.2969 76.1724 46.0401 76.1724 50.6574C76.1724 55.2748 79.9281 59.0181 84.5608 59.0181Z",
    fill: "#EF5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9181 17.2168C44.9181 29.2568 35.1253 39.0172 23.0452 39.0172V45.5797C38.7617 45.5797 51.5026 32.8812 51.5026 17.2168H44.9181Z",
    fill: "#EF5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3373 59.0625C15.428 59.0625 6.58431 67.8766 6.58431 78.75C6.58431 89.6234 15.428 98.4375 26.3373 98.4375C37.2465 98.4375 46.0902 89.6234 46.0902 78.75C46.0902 67.8766 37.2465 59.0625 26.3373 59.0625ZM0 78.75C0 64.2528 11.7916 52.5 26.3373 52.5C40.8829 52.5 52.6745 64.2528 52.6745 78.75C52.6745 93.2472 40.8829 105 26.3373 105C11.7916 105 0 93.2472 0 78.75Z",
    fill: "#EF5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.004 69.2015C36.2897 70.4825 36.2897 72.5602 35.004 73.8418L22.3278 86.4759C21.0422 87.7569 18.9577 87.7569 17.672 86.4759C16.3864 85.1943 16.3864 83.1166 17.672 81.8356L30.3482 69.2015C31.6338 67.9198 33.7184 67.9198 35.004 69.2015Z",
    fill: "#EF5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.672 69.2015C16.3864 70.4825 16.3864 72.5602 17.672 73.8418L30.3482 86.4759C31.6338 87.7569 33.7183 87.7569 35.004 86.4759C36.2897 85.1943 36.2897 83.1166 35.004 81.8356L22.3278 69.2015C21.0422 67.9198 18.9577 67.9198 17.672 69.2015Z",
    fill: "#EF5B5B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentFailed);
export default __webpack_public_path__ + "static/media/payment-failed.904979dbe69abc9b049d49b38aa4bb0c.svg";
export { ForwardRef as ReactComponent };